export default "__VITE_ASSET__mQM2u_Ls__"